/// <reference types="@angular/localize" />

import 'hammerjs';

import { environment } from '@env/environment';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import localeFi from '@angular/common/locales/fi';

import { initSentry } from '@shared/utilities/sentry.utilities';
import { assertLocale } from '@shared/utilities/locales.utilities';
import { brandedFavicon } from '@shared/utilities/branding.utilities';
import { disableConsole } from '@shared/utilities/console.utilities';
import { getTranslations } from '@shared/utilities/translations.utilities';

import { ZefApp } from './app/zef.component';
import { fireProviders } from './app/core/fire.providers';
import { appInitializerProviders, rootProviders } from './app/core/root.providers';
import { storeProviders } from './app/core/store.providers';
import { materialProviders } from './app/core/material.providers';
import { customProviders } from './app/core/custom.providers';

(async () => {
  await initSentry();

  if (environment.production) {
    enableProdMode();
    disableConsole();
    brandedFavicon();
  }

  try {
    await getTranslations(assertLocale());
  } catch {
    window['lang'] = 'en';
  } finally {
    registerLocaleData(localeFi, 'fi-FI');

    await bootstrapApplication(ZefApp, {
      providers: [
        provideZoneChangeDetection(),
        ...rootProviders,
        ...fireProviders,
        ...storeProviders,
        ...materialProviders,
        ...customProviders,
        ...appInitializerProviders,
      ],
    });
  }
})();
